/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IUser } from 'app/shared/model/user.model';

export interface ICustomerCareExecutive {
  id?: string;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  name?: string;
  email?: string;
  gender?: string | null;
  mobile?: string | null;
  dateOfBirth?: number | null;
  bloodGroup?: string | null;
  contactCode?: IContactDetails;
  user?: IUser;
}

export const defaultValue: Readonly<ICustomerCareExecutive> = {
  active: false,
};
